import styled from 'styled-components'
import {Box} from '@mui/material'

export const ExpandedBox = styled(Box)`
  border-bottom: 2px #f1f4f6 solid;
  padding: 20px 0;
`
